.header {
    padding: 8px 16px;
    background-color: var(--off-white);
    font-weight: 500;
    display: flex;
    align-items: center;
}
